<template>
    <div>
        <schedule />
    </div>
</template>

<script>
import store from "../../../store";
import schedule from "./tabs/schedules"
export default {
    data() {
        return {
            tab: null,
            tabs: 2,
            store: store
        };
    },
    created: function() {
        if (this.store.state.user.role == "user")
            this.$router.replace("/dashboard");
        if (!this.store.state.isLoggedIn) this.$router.replace("/login");
    },
    components:{
        schedule,
    }
};
</script>
